import { Button } from '@/components/ui/elements/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/elements/dialog';
import { useToast } from '@/components/ui/elements/use-toast';
import { PolicyGate } from '@/features/auth/authorization';
import { WorkOrderForm } from '@/features/equipment/components/work-orders/WorkOrderForm';
import { WrenchScrewdriverIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

export const ShiftQuickActions = () => {
  const [isReportIssueOpen, setIsReportIssueOpen] = useState(false);
  const { toast } = useToast();

  const handleWorkOrderCreated = () => {
    setIsReportIssueOpen(false);
    toast({
      title: 'Issue Sent',
      description: 'Your issue report has been submitted.',
    });
  };

  return (
    <>
      <section>
        <div className="grid grid-cols-1 gap-2">
          <PolicyGate policy="equipment.work-orders.create">
            <Button
              variant="outline"
              className="h-auto py-2.5 flex-col gap-0.5 text-foreground/70"
              onClick={() => setIsReportIssueOpen(true)}
            >
              <WrenchScrewdriverIcon className="w-5 h-5" />
              <span className="text-xs font-medium">Report Issue</span>
            </Button>
          </PolicyGate>
          {/*
        <Button
          variant="outline"
          className="h-auto py-2.5 flex-col gap-0.5 text-foreground/70"
          onClick={() => navigate({ to: '/map/leads' })}
        >
          <MapPinIcon className="w-5 h-5" />
          <span className="text-xs font-medium">Event Map</span>
        </Button> */}
        </div>
      </section>

      <Dialog open={isReportIssueOpen} onOpenChange={setIsReportIssueOpen}>
        <DialogContent className="left-0 top-0 h-dvh w-screen max-w-none translate-x-0 translate-y-0 rounded-none border-0 p-0">
          <div className="flex h-full flex-col">
            <DialogHeader className="space-y-1 border-b px-4 py-3 text-left sm:px-6 sm:py-4">
              <DialogTitle>Report Issue</DialogTitle>
              <DialogDescription>
                Enter the details for the issue so a new work order can be created.
              </DialogDescription>
            </DialogHeader>
            <div className="flex-1 overflow-y-auto px-4 py-4 sm:px-6 sm:py-6">
              <WorkOrderForm onCreate={handleWorkOrderCreated} allowDelete={false} />
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
